import script from "./scoringAverage.vue?vue&type=script&setup=true&lang=js"
export * from "./scoringAverage.vue?vue&type=script&setup=true&lang=js"

import "./scoringAverage.vue?vue&type=style&index=0&id=63ca6300&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ca6300"]])

export default __exports__